module.exports = __webpack_public_path__ + "img/cktw4.569092a9.jpeg";